
import _ from 'lodash'
import spbkMixin from '@/mixin/or/spbkMixin'
import { commonfunc } from '~/mixin/common'
import { rules } from '~/mixin/common/product/productRules'

export default {
  name: 'ShoppingbagButton',
  mixins: [commonfunc, spbkMixin, rules],
  props: {
    item: {
      type: Object,
      default () { return {} }
    },
    fbYn: { // 정기배송여부
      type: Boolean,
      default: false
    },
    recmYn: { // 추천 솔루션 조회 여부
      type: Boolean,
      default: false
    },
    quickYn: { // 오늘배송 여부
      type: Boolean,
      default: false
    },
    jobCd: { // 업무영역(상품,배송 모듈에 사용)
      type: String,
      default: ''
    },
    spbkSeCd: { // 장바구니유형코드(상품,배송 모듈에 사용)
      type: String,
      default: '01'
    }
  },
  computed: {
    isBulkOrderUnit () {
      return this.$route.path.includes('bulkOrder') || this.$route.params.cartType === 'bulkOrder'
    },
    isQuickExhibition () { // 오늘배송 GNB, 오늘배송 기획전 여부 (최초 GNB 노출 요청은 FO만이었으나 추후 확장을 대비해 C118 조건은 남겨둡니다.)
      return this.quickYn ||
        this.$route.path.includes('C118') ||
        this.$route.fullPath.includes('exbtNo=519') ||
        this.$route.params.cartType === 'quickOrder'
    },
    isPickupOrderUnit () {
      return this.$route.path.includes('pickupOrder') || this.$route.params.cartType === 'pickupOrder'
    }
  },
  methods: {
    cartClick (obj) {
      const productInfo = _.cloneDeep(obj)
      console.log('~~뒤로가기quickyn', this.quickYn, this.item.quickOrPsblYn)
      console.log('~~뒤로가기', this.$route.path, this.isQuickExhibition)

      productInfo.fbYn = this.fbYn
      productInfo.recmYn = this.recmYn
      productInfo.isBulkOrderUnit = this.isBulkOrderUnit
      productInfo.optCn = ''

      productInfo.pkgYn = (this.isBoxGoods(obj) ? 'Y' : '') || (obj.pkgYn ?? obj.PKG_YN)
      if ((productInfo.QUICK_OR_PSBL_YN === 'Y' && this.isQuickExhibition) || (productInfo.quickOrPsblYn === 'Y' && this.isQuickExhibition)) {
        productInfo.spbkSeCd = '05'
      }

      if (productInfo.quickOrPsblYn === 'Y' && this.isQuickExhibition) {
        productInfo.spbkSeCd = '05'
      }

      if (productInfo.pkupOrPsblYn === 'Y' && this.isPickupOrderUnit) {
        productInfo.spbkSeCd = '02'
      }

      if (this.jobCd === 'pd') {
        productInfo.spbkSeCd = this.spbkSeCd
        productInfo.optPdYn = obj.optPdYn === true ? 'Y' : 'N'
        productInfo.bunYn = obj.bundle === true ? 'Y' : 'N'
      }

      if (this.jobCd === 'fb') {
        productInfo.spbkSeCd = this.spbkSeCd
      }

      this.clickAddSpbkBtn(productInfo)
    }
  }
}
